import React, { useEffect, useState } from 'react';

import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { WithSpinner } from 'components/DataDisplay/Spinner/WithSpinner';
import { useAccessBoundary } from 'containers/App/hooks/useAccessBoundary';
import { selectApp } from 'containers/App/selectors';
import { selectSharedState } from 'containers/SharedState/selectors';
import { DataDashboardSideNav } from 'containers/Visibility/Data/Components/DataDashboardSideNav';
import { DataDashboardContextProvider } from 'containers/Visibility/Data/Components/hooks/context';
import { useDataDashboard } from 'containers/Visibility/Data/Components/hooks/useDataDashboard';
import { NoDataScannerDeployed } from 'containers/Visibility/Data/Components/NoDataScannerDeployed';
import { useInjector } from 'utils/inject';

import { dataDashboardSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const Data: React.FC = () => {
  useInjector(sliceKey, reducer, dataDashboardSaga);
  const { environments } = useSelector(selectApp);
  const { dataScannerInfo, isDataScannerDeployed } = useSelector(
    selectSharedState,
  );
  const { environmentId, accountId } = useAccessBoundary();
  const [showDashboard, setShowDashboard] = useState(true);
  const contextValue = useDataDashboard();

  useEffect(() => {
    if (!environmentId || !accountId) return;

    setShowDashboard(isDataScannerDeployed[accountId || environmentId]);
  }, [isDataScannerDeployed, environmentId, accountId]);

  return (
    <DataDashboardContextProvider value={contextValue}>
      <Box h="full">
        <WithSpinner
          loadStatus={{
            loading: dataScannerInfo.isLoading || environments.isLoading,
            loaded: dataScannerInfo.isSuccess,
          }}
          spinnerSize="lg"
        >
          {showDashboard ? <DataDashboardSideNav /> : <NoDataScannerDeployed />}
        </WithSpinner>
      </Box>
    </DataDashboardContextProvider>
  );
};
